import React from 'react';
import PendingActionsIcon from './pendingActions.svg?react';

const PendingActionIcon = () => {
  return <PendingActionsIcon />;
}
export default PendingActionIcon;